import { render } from "./CommunityFeeInfo.vue?vue&type=template&id=0d68e352&scoped=true"
import script from "./CommunityFeeInfo.vue?vue&type=script&lang=js"
export * from "./CommunityFeeInfo.vue?vue&type=script&lang=js"

import "./CommunityFeeInfo.vue?vue&type=style&index=0&id=0d68e352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d68e352"]])

export default __exports__